
import { Search } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useState, useEffect } from "react";

interface SearchBarProps {
  onSearchClick: () => void;
}

export const SearchBar = ({ onSearchClick }: SearchBarProps) => {
  const [isMounted, setIsMounted] = useState(false);
  
  // Ensure we're mounted before rendering interactive elements
  useEffect(() => {
    setIsMounted(true);
  }, []);
  
  const handleClick = () => {
    if (isMounted) {
      onSearchClick();
    }
  };
  
  return (
    <Button
      variant="outline"
      className="w-full justify-start text-muted-foreground hover:text-foreground bg-white border shadow-sm"
      onClick={handleClick}
      disabled={!isMounted}
    >
      <Search className="mr-2 h-4 w-4" />
      Search...
    </Button>
  );
};
